<style>
	.Footer{
		text-align: center;
		padding: 5rem 0;
		text-transform: uppercase;
	}
</style>
<footer class="Footer">
	Sergio Filoth - 2021
</footer>